import { User } from '@akin-home/amplify';

const insertParticipants =
  (users?: User[]) =>
  <T extends { participantIDs: string[]; participants: User[] }>(
    item: T
  ): T => ({
    ...item,
    participants: users?.filter((u) =>
      item.participantIDs?.includes(u.id as string)
    ),
  });

export default insertParticipants;
